import { Routes } from '@angular/router';

import { TaMainRoute, TaRoutes } from '@ta/menu';
import { AuthGuard, LoginRedirectComponent, SignRedirectComponent } from '@ta/user';

import { ECompaniesRoute } from './features/companies/companies.routes';
import { EEstatesRoute } from './features/estates/estates.routes';
import { EFavoritesRoute } from './features/favorites/favorites.routes';
import { EInvitationsRoute } from './features/invitations/invitations.routes';
import { ENotificationsRoute } from './features/notifications/notifications.routes';
import { ERecommendationsRoute } from './features/recommendations/recommendations.routes';
import { EReviewsRoute } from './features/reviews/review.routes';
import { ETenantApplicationsRoute } from './features/tenant-applications/tenant-applications.routes';
import { EUserRoute } from './features/user/user.routes';
import { ESearchRoute } from './features/search/search.routes';
import { EUsersRoute } from './features/users/users.routes';
import { ESubscriptionRoute } from './features/subscription/subscription.routes';
import { EVisitsRoute } from './features/visits/visits.routes';

export const routes: Routes = [
  {
    path: TaRoutes.getUrl([TaMainRoute.HOME]),
    loadComponent: () =>
      import('./features/base/dashboard/dashboard').then((c) => c.HomeDashboardPage),
  },
  {
    path: TaRoutes.getUrl([EUserRoute.user]),
    loadChildren: () => import('./features/user/user.routes').then((m) => m.userRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([ETenantApplicationsRoute.tenantApplications]),
    loadChildren: () =>
      import('./features/tenant-applications/tenant-applications.routes').then(
        (m) => m.tenantApplicationsRoutes,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([EVisitsRoute.visits]),
    loadChildren: () => import('./features/visits/visits.routes').then((m) => m.visitsRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([ESubscriptionRoute.subscription]),
    loadChildren: () =>
      import('./features/subscription/subscription.routes').then((m) => m.subscriptionRoutes),
    canActivate: [AuthGuard],
  },
  {
    // Écran d'attente du retour de paiement.
    path: TaRoutes.getUrl([ESubscriptionRoute.paymentCallback]),
    title: 'app.pages.subscription.title',
    loadComponent: () =>
      import('./features/subscription/pages/payment-callback/payment-callback').then(
        (c) => c.PaymentCallbackPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([EReviewsRoute.reviews]),
    loadChildren: () => import('./features/reviews/review.routes').then((m) => m.reviewsRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([EInvitationsRoute.invitations]),
    loadChildren: () =>
      import('./features/invitations/invitations.routes').then((m) => m.invitationsRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([ENotificationsRoute.notifications]),
    loadChildren: () =>
      import('./features/notifications/notifications.routes').then((m) => m.notificationsRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([ERecommendationsRoute.recommendations]),
    loadChildren: () =>
      import('./features/recommendations/recommendations.routes').then(
        (m) => m.recommendationsRoutes,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: TaRoutes.getUrl([EFavoritesRoute.favorites]),
    loadChildren: () =>
      import('./features/favorites/favorites.routes').then((m) => m.favoritesRoutes),
    canActivate: [AuthGuard],
  },

  /* public */
  {
    path: TaRoutes.getUrl([ESearchRoute.search]),
    loadChildren: () => import('./features/search/search.routes').then((m) => m.searchRoutes),
  },
  {
    path: TaRoutes.getUrl([TaMainRoute.USERLOGIN]),
    component: LoginRedirectComponent,
  },
  {
    path: TaRoutes.getUrl([TaMainRoute.SINGIN]),
    component: SignRedirectComponent,
  },
  {
    path: TaRoutes.getUrl([EUsersRoute.users]),
    loadChildren: () => import('./features/users/users.routes').then((m) => m.usersRoutes),
  },
  {
    path: TaRoutes.getUrl([EEstatesRoute.estates]),
    loadChildren: () => import('./features/estates/estates.routes').then((m) => m.estatesRoutes),
  },
  {
    path: TaRoutes.getUrl([ECompaniesRoute.companies]),
    loadChildren: () =>
      import('./features/companies/companies.routes').then((m) => m.companiesRoutes),
  },
  {
    path: TaRoutes.getUrl([TaMainRoute.REDIRECT]),
    loadComponent: () =>
      import('./features/base/redirect/redirect.component').then((c) => c.RedirectPage),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/base/not-found/not-found.component').then((c) => c.NotFoundPage),
  },
];
